<template>
  <div class="track-multi-picker">
    <label class="field-label">Треки (необязательно)</label>
    <select v-model="selectedIds" class="input" multiple size="6" @change="emitSelection">
      <option v-for="track in tracks" :key="track.id" :value="String(track.id)">
        {{ track.name }}
      </option>
    </select>
    <p class="track-item-meta">Удерживайте Ctrl (Cmd на Mac) для выбора нескольких треков</p>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { fetchTracks } from '../api/tracks'

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['update:modelValue'])

const tracks = ref([])
const selectedIds = ref(props.modelValue.map(String))

watch(
  () => props.modelValue,
  (value) => {
    selectedIds.value = value.map(String)
  },
  { deep: true }
)

function emitSelection() {
  emit('update:modelValue', selectedIds.value.map((id) => Number(id)))
}

async function loadTracks() {
  const { data } = await fetchTracks()
  tracks.value = data
}

onMounted(loadTracks)
</script>

<style scoped>
.track-multi-picker {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.field-label {
  font-weight: 600;
}

.track-multi-picker select {
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  padding: 0.625rem 0.75rem;
}
</style>
